import { SelectField, useFormContext } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useEffect, forwardRef } from 'react';
import { INPUT_COMPONENT_NAME, ORG_MEMBERSHIP_ACCESS_OWNER_TYPE } from './constants';
const styledSelectFieldCss = "sgcvsl7";
const StyledSelectField = forwardRef((props, ref) => <SelectField ref={ref} {...props} className={classNames(styledSelectFieldCss, props.className)} />);
export const OrgMemberAccessOwnerSelectDropdown = ({
  hasExistingSetting,
  options
}) => {
  const {
    values: {
      accessOwnerType,
      existingSettingType,
      existingSettingValue
    },
    setFieldValue,
    setErrors
  } = useFormContext();
  useEffect(() => {
    if (accessOwnerType === ORG_MEMBERSHIP_ACCESS_OWNER_TYPE && options.length > 0) {
      // Since we sort by human_role in descending order, owner will always be first
      const defaultValue = options[0].value;
      const currentValue = hasExistingSetting && ORG_MEMBERSHIP_ACCESS_OWNER_TYPE === existingSettingType ? existingSettingValue : defaultValue;
      setFieldValue(INPUT_COMPONENT_NAME, currentValue);
    }
    setErrors({});
  }, [accessOwnerType, hasExistingSetting, existingSettingType, existingSettingValue, setFieldValue, options, setErrors]);
  if (ORG_MEMBERSHIP_ACCESS_OWNER_TYPE !== accessOwnerType) {
    return null;
  }
  return <StyledSelectField label={I18n.t('publisher.organization_settings.domain_control.domain_control_settings.form.org_membership_prompt')} name={INPUT_COMPONENT_NAME} options={options} />;
};
OrgMemberAccessOwnerSelectDropdown.propTypes = {
  hasExistingSetting: PropTypes.bool.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.element,
    value: PropTypes.string
  }))
};

require("./org_member_access_owner_select_dropdown.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./org_member_access_owner_select_dropdown.js");